import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import type { ArtistDetails } from '~/modules/artist-roster/lib/types';

import { formatDateByLocale } from '../TrackList/utils';
import { trackDetails } from './mockData';
import { getTrackTitleAsArray } from './utils';

interface TrackPreReleaseTrackDetailsProps {
  artistData: ArtistDetails;
}

export function TrackPreReleaseTrackDetails({
  artistData,
}: TrackPreReleaseTrackDetailsProps) {
  const { t } = useTranslation('roster');
  const [trackTitleMain, trackTitleInParentheses] = getTrackTitleAsArray(
    trackDetails.title,
  );

  return (
    <>
      {artistData?.image ? (
        <img
          src={artistData.image}
          alt={trackDetails.title}
          className="size-[6rem] flex-none place-self-center rounded-xs object-cover"
        />
      ) : (
        <div className="flex size-[6rem] items-center justify-center bg-level-03">
          <Icon
            type="user"
            variant="light"
            aria-label={t('labels.emptyAvatar')}
          />
        </div>
      )}
      <div className="flex min-w-0 shrink flex-col place-content-center">
        <div className="mb-sm truncate text-headline-sm leading-tight">
          <span className="font-bold">{trackTitleMain}</span>
          <span>{trackTitleInParentheses}</span>
        </div>
        <div className="mb-md text-caption-md font-semibold leading-tight">
          {trackDetails.artists}
        </div>
        <div className="text-caption-md text-subtle">
          <Trans
            t={t}
            i18nKey="trackPreReleaseList.trackDetails.releaseDateColonDate"
            components={{
              label: <span className="font-semibold" />,
              date: <span className="whitespace-nowrap" />,
            }}
            values={{
              date: formatDateByLocale(trackDetails.releaseDate),
            }}
          />
        </div>
      </div>
    </>
  );
}

TrackPreReleaseTrackDetails.displayName = 'TrackPreReleaseTrackDetails';
